export const STATUS_OK: string = "#40916c"
export const STATUS_BAD: string = "#e63946"
export const McK_ELECTRIC_BLUE: string = "#2251FF"
export const McK_DEEP_BLUE: string = "#051C2C"
export const McK_DARK_GRAY: string = "#333333"
